import Footer from "../../Components/layout/Footer";
import Navbar from "../../Components/layout/NavBar";

export default function PublicLayout({
  children,
  isFooter = true,
  isHeader = true,
  className
}) {
  return (
    <main className={className}>
      {isHeader && <Navbar />}
      {children}
      {isFooter && <Footer />}
    </main>
  );
}
